import { IMarketingBonusCalculationAllCompaniesDTO, IMarketingBonusCalculationAllCompaniesStatusDTO, IMarketingBonusCalculationOneCompanyDTO, IMarketingBonusCalculationOneCompanyStatusDTO } from "../../coreapi-dto/dirs/marketingBonusCalculator";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import BaseCoreApiRequest from "../baseCoreApiRequest";
import { CoreApiResponse, IRequestEventHandler } from "../common";

class MarketingBonusCalculatorRequest extends BaseCoreApiRequest {
    private _routePrefix: string = "ProfitRestore/Companies";
    private _token: string;
    private _eventHandler: IRequestEventHandler;

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl);
        this._token = token;
        this._eventHandler = eventHandler;
    }

    calculateAll(params: Record<string, string>, callback?: (e: CoreApiResponse<IMarketingBonusCalculationAllCompaniesDTO>) => void, signal?: AbortSignal | null) {
        super.post<IMarketingBonusCalculationAllCompaniesDTO>(
            `${this._baseUrl}/${this._routePrefix}/CalculateAll?force=${params.force}`,
            undefined,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IMarketingBonusCalculationAllCompaniesDTO>) => {
                callback?.(e);
            },
            signal
        );
    }

    calculateOne(idGlobal: string, params: Record<string, string>, callback?: (e: CoreApiResponse<IMarketingBonusCalculationOneCompanyDTO>) => void, signal?: AbortSignal | null) {
        super.post<IMarketingBonusCalculationOneCompanyDTO>(
            `${this._baseUrl}/${this._routePrefix}/CalculateOne?companyId=${idGlobal}&force=${params.force}`,
            undefined,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IMarketingBonusCalculationOneCompanyDTO>) => {
                callback?.(e);
            },
            signal
        );
    }

    getStatusOne(companyId: string, callback?: (e: CoreApiResponse<IMarketingBonusCalculationOneCompanyStatusDTO>) => void) {
        super.get<IMarketingBonusCalculationOneCompanyStatusDTO>(
            `${this._baseUrl}/${this._routePrefix}/CalculateOne/Status/${companyId}`,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IMarketingBonusCalculationOneCompanyStatusDTO>) => {
                callback?.(e);
            },
        );
    }

    getStatusAll(executionId: string, callback?: (e: CoreApiResponse<IMarketingBonusCalculationAllCompaniesStatusDTO>) => void) {
        super.get<IMarketingBonusCalculationAllCompaniesStatusDTO>(
            `${this._baseUrl}/${this._routePrefix}/CalculateAll/Status/${executionId}`,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IMarketingBonusCalculationAllCompaniesStatusDTO>) => {
                callback?.(e);
            },
        );
    }

    getStatusAllLast(callback?: (e: CoreApiResponse<IMarketingBonusCalculationAllCompaniesStatusDTO>) => void) {
        super.get<IMarketingBonusCalculationAllCompaniesStatusDTO>(
            `${this._baseUrl}/${this._routePrefix}/CalculateAll/Last`,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IMarketingBonusCalculationAllCompaniesStatusDTO>) => {
                callback?.(e);
            },
        );
    }

    getStatusAllByJobId(jobId: string, callback?: (e: CoreApiResponse<IMarketingBonusCalculationAllCompaniesStatusDTO>) => void) {
        super.get<IMarketingBonusCalculationAllCompaniesStatusDTO>(
            `${this._baseUrl}/${this._routePrefix}/CalculateAll/Status/Hangfire/${jobId}`,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IMarketingBonusCalculationAllCompaniesStatusDTO>) => {
                callback?.(e);
            },
        );
    }

    
}

export default MarketingBonusCalculatorRequest;
